module.exports = __webpack_public_path__ + "img/projects-shape-1.7a931e7d.png";